<span *ngIf="name || src" [title]="title">
  <ion-icon [name]="name" [src]="src" [ngClass]="alignmentClass"></ion-icon>
</span>
